/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLinen = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 4h1v8H7a4.978 4.978 0 0 0-3 1V7a3 3 0 0 1 3-3zm3 0h1v8h-1zm3 0h2v5h5v3.17c-.313-.11-.65-.17-1-.17h-6zm4 1.414L18.586 7H17zM20 15a1 1 0 0 1-1 1H7v2h12a1 1 0 1 1 0 2H7a3 3 0 1 1 0-6h12a1 1 0 0 1 1 1zm1.236 2c.475-.53.764-1.232.764-2V7.586L16.414 2H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h12a3 3 0 0 0 2.236-5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLinen as Linen };
